/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertId } from './InternalApiAlertId';
import {
    InternalApiAlertIdFromJSON,
    InternalApiAlertIdFromJSONTyped,
    InternalApiAlertIdToJSON,
    InternalApiAlertIdToJSONTyped,
} from './InternalApiAlertId';

/**
 * 
 * @export
 * @interface InternalApiDetachCaseAlertsRequest
 */
export interface InternalApiDetachCaseAlertsRequest {
    /**
     * 
     * @type {Array<InternalApiAlertId>}
     * @memberof InternalApiDetachCaseAlertsRequest
     */
    alerts: Array<InternalApiAlertId>;
}

/**
 * Check if a given object implements the InternalApiDetachCaseAlertsRequest interface.
 */
export function instanceOfInternalApiDetachCaseAlertsRequest(value: object): value is InternalApiDetachCaseAlertsRequest {
    if (!('alerts' in value) || value['alerts'] === undefined) return false;
    return true;
}

export function InternalApiDetachCaseAlertsRequestFromJSON(json: any): InternalApiDetachCaseAlertsRequest {
    return InternalApiDetachCaseAlertsRequestFromJSONTyped(json, false);
}

export function InternalApiDetachCaseAlertsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiDetachCaseAlertsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'alerts': ((json['alerts'] as Array<any>).map(InternalApiAlertIdFromJSON)),
    };
}

export function InternalApiDetachCaseAlertsRequestToJSON(json: any): InternalApiDetachCaseAlertsRequest {
    return InternalApiDetachCaseAlertsRequestToJSONTyped(json, false);
}

export function InternalApiDetachCaseAlertsRequestToJSONTyped(value?: InternalApiDetachCaseAlertsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alerts': ((value['alerts'] as Array<any>).map(InternalApiAlertIdToJSON)),
    };
}

